<div class="dialog-padding">
  <h1 mat-dialog-title>Create a New Payment</h1>
  <div mat-dialog-content>
    <form [formGroup]="newPaymentForm">
      <mat-form-field appearance="outline">
        <mat-label>Amount</mat-label>

        <input id="newPaymentDialog-input-amount" formControlName="amount" matInput uzCurrencyInput ciCurrencyCode="USD" />
      </mat-form-field>
      <br />
      <mat-form-field class="description-field" appearance="outline">
        <mat-label>Description</mat-label>
        <textarea id="newPaymentDialog-textArea-description" width="300" height="300" formControlName="description" matInput> </textarea>
      </mat-form-field>
      <app-payment-account-selector
        formControlName="selectedAccount"
        [paymentAccounts]="data.paymentAccounts"
      ></app-payment-account-selector>
    </form>
  </div>
  <div mat-dialog-actions align="end">
    <button id="newPaymentDialog-button-close" mat-button (click)="close()">Close</button>&nbsp;
    <button
      id="newPaymentDialog-button-submitPayment"
      [disabled]="!(newPayment.amount > 0 && newPayment.description.length > 0 && newPayment.selectedAccount.id)"
      mat-raised-button
      color="primary"
      uzDebounceClick
      (debounceClick)="handleSubmitPayment($event)"
    >
      Submit Payment
    </button>
  </div>
</div>
